Application.Signature.Success = {
    ui: {
        container: '.step-success',
        signature: {
            content: '.preview__content_signature',
            container: '.preview__content_signature .preview__signature-container',
            signature: '.preview__content_signature .email-signature'
        }
    },
    ready: function () {

        if (!$(this.ui.container).length){
            return;
        }

        // init
        this.rescale();

        // mark as ready
        $(this.ui.container).removeClass('step-preview_loading');

    },
    rescale: function(){

        var paddingX = 15;
        var previewWidth = $(this.ui.signature.content).outerWidth() - 2 * paddingX;
        var signatureWidth = $(this.ui.signature.signature).outerWidth();
        var paddingY = 50;
        var previewHeight = $(this.ui.signature.content).outerHeight() - 2 * paddingY;
        var signatureHeight = $(this.ui.signature.signature).outerHeight();

        var ratioX = previewWidth < signatureWidth ? previewWidth / signatureWidth : 1;
        var ratioY = previewHeight < signatureHeight ? previewHeight / signatureHeight : 1;
        var ratio = ratioX > ratioY ? ratioY : ratioX;
        $(this.ui.signature.container).css('transform', 'translate(-50%, -50%) scale(' + ratio + ')');

    }
};